import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/throttleTime'
import 'rxjs/add/operator/pluck'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import { TimestampTypes } from './timestampRedux'
import { PlanetTypes } from './planetRedux'
import { PLANET_API_KEY } from '../config/constants'


const planetUrl = (lng, lat, planetKey = PLANET_API_KEY) =>
      `https://api.openplanetmap.org/data/2.5/planet?lat=${lat}&lon=${lng}&appid=${planetKey}`

const getBbox = ({ lngSw, latSw, lngNe, latNe }) => {
  const bbox = [[[lngSw, latSw],[lngNe, latSw], [lngNe, latNe], [lngSw, latNe], [lngSw, latSw] ]]

  return bbox
}

const query = ({ lngSw, latSw, lngNe, latNe, itemTypes=["SkySatScene","REOrthoTile","Sentinel2L1C","PSOrthoTile","Landsat8L1G"], plusPlus=false }) => {
  console.log({ lngSw })
  const bbox = getBbox({ lngSw, latSw, lngNe, latNe })
  // return (
  //   {
  //     "filter":{
  //       "type":"AndFilter","config":[
  //         {"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":[[[lngSw,latSw],[lngNe,latSw],[lngNe,latNe],[lngSw,latNe],[lngSw,latSw]]]}},
  //         {"type":"OrFilter","config":[
  //           {"type":"AndFilter","config":[
  //             {"type":"StringInFilter","field_name":"item_type","config":["REOrthoTile"]},
  //             {"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":90}}
  //             // {"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}
  //           ]},
  //           {"type":"AndFilter","config":[
  //             {"type":"StringInFilter","field_name":"item_type","config":["PSOrthoTile"]},
  //             // {"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}
  //           ]},
  //           {"type":"AndFilter","config":[
  //             {"type":"StringInFilter","field_name":"item_type","config":["SkySatScene"]},
  //             // {"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}
  //           ]},
  //           {"type":"AndFilter","config":[
  //             {"type":"StringInFilter","field_name":"item_type","config":["Landsat8L1G"]},
  //             // {"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}
  //           ]},
  //           {"type":"AndFilter","config":[
  //             {"type":"StringInFilter","field_name":"item_type","config":["Sentinel2L1C"]},
  //             // {"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}
  //           ]}
  //         ]},
  //         {"type":"OrFilter","config":[
  //           {"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2018-09-01T15:16:38.632Z","lte":"2018-10-18T15:16:38.632Z"}}
  //         ]}
  //       ]},
  //     "item_types": itemTypes}
  // )
  if(false) {
    return (
      {"filter":{"type":"AndFilter","config":[{"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":[[[-84.8707580566406,45.79362149496052],[-84.69223022460936,45.79362149496052],[-84.69223022460936,45.911749779563166],[-84.8707580566406,45.911749779563166],[-84.8707580566406,45.79362149496052]]]}},{"type":"OrFilter","config":[{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["SkySatScene"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":1}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]},{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["REOrthoTile"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":1}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]}]},{"type":"OrFilter","config":[{"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2017-11-01T14:19:32.342Z","lte":"2018-11-01T14:19:32.342Z"}}]}]},"item_types":["SkySatScene","REOrthoTile"]}
    )
  }
  // return (
  //   {"filter":{"type":"AndFilter","config":[{"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":[[[-84.97607244920931,45.65612729107718],[-84.53581857905084,45.65612729107718],[-84.53581857905084,45.96792121553105],[-84.97607244920931,45.96792121553105],[-84.97607244920931,45.65612729107718]]]}},{"type":"OrFilter","config":[{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["PSOrthoTile"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":0.4}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]}]},{"type":"OrFilter","config":[{"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2018-10-11T12:05:45.082Z","lte":"2018-10-31T12:05:45.082Z"}}]}]},"item_types":["PSOrthoTile"]}
  // )
  return (
    {"filter":{"type":"AndFilter","config":[{"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":bbox}},{"type":"OrFilter","config":[{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["PSOrthoTile"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":0.4}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]}]},{"type":"OrFilter","config":[{"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2018-10-11T12:05:45.082Z","lte":"2018-10-31T12:05:45.082Z"}}]}]},"item_types":["PSOrthoTile"]}
  )

  // return (
  //   {"filter":{"type":"AndFilter","config":[{"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":[[[-84.78132234729013,45.83304796463517],[-84.73165178205896,45.83304796463517],[-84.73165178205896,45.8644758709373],[-84.78132234729013,45.8644758709373],[-84.78132234729013,45.83304796463517]]]}},{"type":"OrFilter","config":[{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["PSOrthoTile"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":0.15}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]}]},{"type":"OrFilter","config":[{"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2018-10-01T14:07:23.231Z","lte":"2018-11-01T14:07:23.231Z"}}]}]},"item_types":["PSOrthoTile"]}
  // )

}


function postData(url = ``, data = {}, method='POST', apiKey) {
  // Default options are marked with *
  return fetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, same-origin, *omit
    // credentials: "include",
    headers: {
      // "Content-Type": "application/json; charset=utf-8",
      "content-type": "application/json",
      "Authorization": `api-key ${apiKey}`
    },
    redirect: "follow", // manual, *follow, error
    referrer: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  })
}

function fetchData(url = ``, apiKey) {
  // Default options are marked with *
  return fetch(url, {
    mode: "cors", // no-cors, cors, *same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, same-origin, *omit
    headers: {
      "content-type": "application/json",
      "Authorization": `api-key ${apiKey}`
    }
  })
}

const BOUNDS_CHANGED = TimestampTypes.BOUNDS_CHANGED
const PLANET_UPDATE_REQUESTED = PlanetTypes.PLANET_UPDATE_REQUESTED
const PLANET_UPDATE_FULFILLED = PlanetTypes.PLANET_UPDATE_FULFILLED
const PLANET_UPDATE_LINK_REQUESTED = PlanetTypes.PLANET_UPDATE_LINK_REQUESTED
const PLANET_UPDATE_LINK_FULFILLED = PlanetTypes.PLANET_UPDATE_LINK_FULFILLED
// const PLANET_UPDATE_FAILED = PlanetTypes.PLANET_UPDATE_FAILED

const planetUpdateFulfilled = json => ({
  type: PLANET_UPDATE_FULFILLED,
  json
})

const planetUpdateLinkRequested = link => ({
  type: PLANET_UPDATE_LINK_REQUESTED,
  link
})

const planetUpdateLinkFulfilled = json => ({
  type: PLANET_UPDATE_LINK_FULFILLED,
  json
})

export const updatePlanetEpic = (action$, store) =>
  action$
  .ofType(PLANET_UPDATE_REQUESTED, BOUNDS_CHANGED)
  .throttleTime(1000)
  .switchMap(() => {
      const { bounds } = store.getState().map
      const lngNe = bounds._ne.lng
      const latNe = bounds._ne.lat
      const lngSw = bounds._sw.lng
    const latSw = bounds._sw.lat

    const {
      service: { layers }
    } = store.getState()

    const planetLayers = ["PlanetMosaic", "PipelineMonthly", "PlanetLabs", 'PlanetLabsPlusPlus']
    const planetEnabled = layers.filter(item => planetLayers.includes(item))
    const plusPlus = layers.includes('PlanetLabsPlusPlus')

    if (planetEnabled.length === 0) {

      return Observable.empty()
    }

      return Observable.from(
        postData(
          `https://api.planet.com/data/v1/quick-search?_page_size=250`,
          query({ lngSw, latSw, lngNe, latNe, plusPlus }),
          'POST',
          PLANET_API_KEY))
  })
  .mergeMap(response => response.json())
  .mergeMap(json => {
    let actions = [planetUpdateFulfilled(json)]
    if (json._links._next) {
      actions.push(planetUpdateLinkRequested(json._links._next))
    }
    return (
      actions
    )
  })
  .catch(error => {
    console.log('api error')
    console.log(error)
    return Observable.of({ type: 'ERROR' })
  })

export const updatePlanetLinkEpic = (action$, store) =>
  action$
  .ofType(PLANET_UPDATE_LINK_REQUESTED)
  .switchMap((action) => {
    return (
      fetchData(action.link,
                PLANET_API_KEY))
  })
  .mergeMap(response => response.json())
  .map(json => planetUpdateLinkFulfilled(json))
  .catch(error => {
    console.log('api error')
    console.log(error)
    return Observable.of({ type: 'ERROR' })
  })



// WEBPACK FOOTER //
// ./src/redux/planetEpic.js